// extracted by mini-css-extract-plugin
module.exports = {"hidden":"event_hidden__ydF8v","textEmphasis":"event_textEmphasis__EMu2f","area":"event_area__X8Ry_","wrap":"event_wrap__60yC_","listWrap":"event_listWrap__Zxt_W"};